var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgLoginLogo = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 90,
    height: 32,
    viewBox: "0 0 90 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3559_23525)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M65.6208 23.6596H72.3955L89.111 0.0597534H83.221L65.6208 23.6596Z",
    fill: "#70C6E9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.8492 12.0775C50.8492 12.6772 50.8026 13.2651 50.7212 13.8648L32.504 13.7943C32.8416 15.8521 34.2501 17.1103 35.2744 17.8746C36.3104 18.6389 37.9284 18.9093 39.2205 18.9093C41.0131 18.9093 43.1317 17.9216 44.319 16.487L47.1476 20.779C44.8777 22.9544 42.1888 24.0362 39.0692 24.0362C35.7633 24.0362 32.9696 22.8838 30.6765 20.5673C28.3834 18.2509 27.231 15.4287 27.231 12.101C27.231 8.80856 28.3834 5.99821 30.6998 3.68173C33.0162 1.36525 35.7982 0.212891 39.0692 0.212891C42.3401 0.212891 45.1222 1.36525 47.4153 3.68173C49.6968 5.98645 50.8492 8.78504 50.8492 12.0775ZM45.2735 9.22011C44.2724 6.89188 41.8512 5.1163 39.0226 5.1163C36.1591 5.1163 33.7146 6.79781 32.7485 9.22011H45.2735Z",
    fill: "#1595D2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.9127 3.79904C58.2757 1.42377 64.0493 -2.20969 71.8833 2.44678L68.4261 6.45653C63.6536 4.15181 61.1509 6.25663 60.045 7.44426C58.7646 8.79652 58.1942 10.3487 58.1244 12.2654V23.9653L52.3624 23.9771V12.43C52.3741 9.04346 53.5497 6.17432 55.9127 3.79904Z",
    fill: "#1595D2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.617 9.5491C7.96621 8.71423 8.4551 7.97342 9.0604 7.36197C9.6657 6.73875 10.3874 6.24489 11.2139 5.88036C12.0403 5.51584 12.9366 5.3277 13.8911 5.3277C14.834 5.3277 15.7187 5.51584 16.5568 5.8686C17.3832 6.23313 18.1049 6.72699 18.7219 7.36197C19.3388 7.98518 19.8161 8.71423 20.1769 9.5491C20.5378 10.384 20.7124 11.2659 20.7124 12.2066C20.7124 13.1473 20.5378 14.0292 20.1769 14.8641C19.8277 15.6989 19.3388 16.428 18.7219 17.0512C18.1049 17.6862 17.3832 18.18 16.5568 18.5446C15.7303 18.9091 14.8456 19.0972 13.9028 19.0972C12.9483 19.0972 12.052 18.9208 11.2255 18.5563C10.399 18.1918 9.67734 17.6979 9.07204 17.0747C8.46674 16.4515 7.97785 15.7225 7.62864 14.8876C7.26779 14.0527 7.09318 13.159 7.09318 12.2183C7.09318 11.2659 7.26779 10.384 7.617 9.5491ZM18.6753 23.0952C20.0372 22.4955 21.2944 21.6018 22.4468 20.4025C24.6934 18.0625 25.7876 15.2521 25.7177 11.9361C25.6828 10.3017 25.3685 8.78478 24.7632 7.38549C24.1696 5.98619 23.2733 4.73976 22.1092 3.61092C19.7462 1.34147 16.9525 0.306702 13.7398 0.306702C10.7832 0.306702 7.72176 1.15333 5.14925 3.81082C-4.81488 13.1355 3.99685 31.7614 3.99685 31.7614L8.90908 28.8335C7.02334 24.6944 6.11539 21.108 6.11539 21.108C8.75775 23.5773 11.7377 24.0947 14.2171 24.0477C15.8234 24.0124 17.3134 23.7067 18.6753 23.0952Z",
    fill: "#1595D2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.9353 23.9536H81.3702L70.533 8.78477L74.1066 4.53986L87.9353 23.9536Z",
    fill: "#1595D2"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M30.5252 27.0109H47.4851L44.028 31.6556H27.068L30.5252 27.0109Z",
    fill: "#EF5A25"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3559_23525"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 90,
    height: 32,
    fill: "white"
  })))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgLoginLogo);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/login_logo.b6b1a98c586f85c90136415a24018509.svg";